export const ConsoleColor = {
    ANALYTICS: '#8897C9',
    TRIGGER: '#F6AFB1',
    EVENT: '#E5808E',
};
let enabled = false;
export const enableLogger = () => {
    enabled = true;
};
export const logData = (category, title, data, color = 'inherit') => {
    if (!enabled) {
        return;
    }
    const now = new Date().toISOString().slice(11, 23);
    console.groupCollapsed(`%cAnalytics%c - %c${category}%c: ${title}%c @ ${now}`, `color: ${ConsoleColor.ANALYTICS}; font-weight: bold;`, 'color: inherit; font-weight: normal;', `color: ${color};`, 'color: inherit;', 'color: gray; font-weight: normal;');
    console.log(data);
    console.groupEnd();
};
export const logWarning = (category, title, data, url = '') => {
    if (!enabled) {
        return;
    }
    const now = new Date().toISOString().slice(11, 23);
    console.warn(`%cAnalytics%c - %c${category}%c: ${title}%c @ ${now} ${url}`, `color: ${ConsoleColor.ANALYTICS}; font-weight: bold;`, 'color: inherit; font-weight: normal;', `color: darkred;`, 'color: inherit;', 'color: gray; font-weight: normal;');
};
//# sourceMappingURL=console.js.map